export const AppConsts = {
  authorizationKey: "Authorization",
  currentUserKey: "unileverUser",
  currentCustomerKey: "unileverCustomer",
  campaignConfig: "UgiftCampaignConfig",
  phoneNumberScanQrFlow: "PhoneNumberScanQrFlow",
  getCampaignByStaffID: "GetCampaignByStaffID",
  mechanicListConfig: "UgiftMechanicListConfig",
  mechanicCode: "UgiftMechanicCode",
  signalRCurrentSession: "SignalRCurrentSession",
  returnUrl: "returnUrl",
  accessToken: "accessToken",
  phoneExisted: "exist",
  vnTimeNeverExpired: "XEM THÊM >",
  vnDotPattenDate: "dd.MM.yyyy",
  vnLinePattenDate: "dd/MM/yyyy",
  remainingDateDisplay: 3,
  phonePatten: /[0-9]+/,
  namePatten:
    /[^\~\!\@\#\$\%\^\&\*\(\)\_\+\{\}\|\:\"\<\>\?\`\[\]\\\;\'\,\.\/0-9]+/,

  ocrResponseKey: "OCR_RESPONSE_KEY",
  invoiceUpdateResponseKey: "INVOICE_RESPONSE_KEY",
  topUIConfig: "UgiftUIConfig",
  currentTransactionId: "currentTransactionId",
  // FileType

  fileType: {
    redemptionFile: "Redemption",
    ocrFile: "OCR",
    invoiceEvident: "InvoiceEvident",
  },

  // Screen name
  screenName: {
    giveGift: "GiveGift",
    luckyDraw: "LuckyDraw",
    capture: "Capture",
    listOfPurchase: "ListOfPurchase",
  },

  productType: {
    TopupVoucher: "TopupVoucher",
    GotItVoucher: "GotItVoucher",
    GotItTopup: "GotItTopup",
    GotItTopup2: "GotItTopup2",
    MobileTopup: "MobileTopup",
  },
  // Camera type
  cameraType: {
    html5: "type1",
    plugin: "type2",
    external: "type3",
    complex: "type4",
  },
};

export const ALLOW_BROWSERS_ANDROID = [
  "mobile chrome",
  "chrome mobile",
  "samsung internet",
  "brave",
];
export const ALLOW_BROWSERS_IOS = ["chrome mobile ios", "mobile safari"];
